"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCheckCircleBroken = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11a10.97 10.97 0 0 0-.792-4.105c-.213-.53-.32-.795-.572-.966-.2-.136-.517-.2-.754-.154-.3.059-.532.292-.998.758l-7.177 7.184a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L12 12.595l6.978-6.984c.375-.377.563-.565.635-.81a1.088 1.088 0 0 0-.034-.656c-.096-.238-.276-.384-.636-.677A10.954 10.954 0 0 0 12 1Z", fill: "currentColor" }) }))); };
exports.default = SvgCheckCircleBroken;
